/**
 * Escudos de clubes brasileiros via ESPN CDN — sem API key, sem fetch.
 * URL: https://a.espncdn.com/i/teamlogos/soccer/500/{espnId}.png
 *
 * IDs obtidos de:
 *   Série A 2026: site.api.espn.com/apis/site/v2/sports/soccer/bra.1/teams
 *   Série B 2026: site.api.espn.com/apis/site/v2/sports/soccer/bra.2/teams
 *
 * Não requer variável de ambiente. Funciona imediatamente no primeiro render.
 * fetchTeamLogos() e onCrestsLoaded() mantidos para compatibilidade com os
 * call-sites existentes (AppContext, TeamFlag) — ambos são no-ops.
 */

const ESPN_IDS = {
  // ── Série A 2026 ──────────────────────────────────────────────────────────
  'Athletico-PR':       3458,
  'Atlético-MG':        7632,
  'Bahia':              9967,
  'Botafogo':           6086,
  'Corinthians':         874,
  'Coritiba':           3456,
  'Cruzeiro':           2022,
  'Flamengo':            819,
  'Fluminense':         3445,
  'Fortaleza':          6272,
  'Grêmio':             6273,
  'Internacional':      1936,
  'Mirassol':           9169,
  'Palmeiras':          2029,
  'Bragantino':         6079,
  'Remo':               4936,
  'Santos':             2674,
  'São Paulo':          2026,
  'Vasco':              3454,
  'Vitória':            3457,

  // ── Série B 2026 ──────────────────────────────────────────────────────────
  'América-MG':         6154,
  'Athletic':          20851,
  'Atlético-GO':       10357,
  'Avaí':               9966,
  'Botafogo-SP':       10281,
  'CRB':                9970,
  'Ceará':              9969,
  'Chapecoense':        9318,
  'Criciúma':           9971,
  'Cuiabá':            17313,
  'Goiás':              3395,
  'Juventude':          6270,
  'Londrina':          17333,
  'Novorizontino':     18127,
  'Náutico':            7633,
  'Operário-PR':       18187,
  'Ponte Preta':        3459,
  'Sport':              7635,
  'São Bernardo':      11268,
  'Vila Nova':          9973,
};

const BASE = 'https://a.espncdn.com/i/teamlogos/soccer/500';

/** Retorna a URL do escudo ou null se o time não estiver mapeado. */
export const getTeamCrest = (team) => {
  const id = ESPN_IDS[team];
  return id ? `${BASE}/${id}.png` : null;
};

/** No-op — mantido para compatibilidade com AppContext. */
export const fetchTeamLogos = () => Promise.resolve();

/**
 * Chama o callback imediatamente (URLs já disponíveis de forma síncrona).
 * Mantido para compatibilidade com TeamFlag.
 */
export const onCrestsLoaded = (cb) => {
  try { cb(); } catch (e) { /* isolate */ }
  return () => {};
};
